// frontend/src/pages/visitor/PaymentCancel.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'react-feather';
import Button from '../../components/common/Button';

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();
  
  const handleReturn = () => {
    navigate(-1); // Go back to previous page
  };
  
  return (
    <div className="min-h-screen flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-md w-full bg-white shadow rounded-lg p-8">
        <div className="text-center">
          <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-red-100 text-red-500 mb-4">
            <XCircle className="h-6 w-6" />
          </div>
          <h2 className="text-xl font-medium text-gray-900">Payment Cancelled</h2>
          <p className="mt-2 text-sm text-gray-500">
            Your payment was cancelled. No charges were made to your account.
          </p>
          <div className="mt-6">
            <Button onClick={handleReturn} leftIcon={<ArrowLeft className="h-4 w-4" />}>
              Go Back
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;